
import React, { useState } from 'react';
import { connect } from "react-redux"
import Body from "./components/body/Body";
import { saveCliente } from "./redux/actions/clienteActions";
import { ApplicationState } from "./redux/reducers";
import { setUsuario } from "./redux/actions/usuarioActions";
import useCommonApi from "./api/useCommonApi";
import { escucharRenovaciones, guardarSesion, obtenerSesion, registrarApertura, retirarSesion, retirarTokenDeLaDireccion, RUTA_DE_APERTURA } from "./api/sesionPortal";
import { IResultApi } from "./interfaces/IResultApi";
import { ICliente } from "./entities/catalogos/ICliente";
import { IUsuario } from "./entities/catalogos/IUsuario";
import { setSolicitud } from "./redux/actions/solicitudActions";
import { setRecoleccionDestino, setRecoleccionOrigen } from './redux/actions/recoleccionActions';
import { saveMercancias } from './redux/actions/mercanciaActions';
import { CotizacionHistorialDto } from './entities/cotizaciones/ICotizacionHistorialDto';
import LoadingDialog from './components/controls/LoadingDialog';
import swal from 'sweetalert2'
import BodySolicitud from './components/body/BodySolicitud';
import BodyCotizacion from './components/body/BodyCotizacion';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { setAyuda } from './redux/actions/ayudaActions';
import ayudasVisuales from './components/help/ayudas-visuales.json';
import { loadPaises } from "./redux/actions/paisActions";
import { traducirLabel } from  './blocks/traductor';
import AutoLogout from './AutoLogout';

import { loadDiasFestivos } from './redux/actions/diasFestivosActions';
import { loadSucursalesMany } from './redux/actions/sucursalManyActions';

import ControlBroadcastChannel from './ControlBroadcastChannel';
import SesionCerrada from './components/SesionCerrada/SesionCerrada';
// App.tsx (fragmento - nuevos imports) folio 4680
import BodyCargaMasiva from './components/body/BodyCargaMasiva';
import BodyGuia from './components/body/BodyGuia';
import BodyGuiaConsulta from './components/body/BodyGuiaConsulta';


interface DispatchProps {
    saveCliente: typeof saveCliente
    setUsuario: typeof setUsuario
    setSolicitud: typeof setSolicitud
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    saveMercancias: typeof saveMercancias
    setAyuda: typeof setAyuda,
    loadPaises: typeof loadPaises,
    loadDiasFestivos: typeof loadDiasFestivos,
    loadSucursalesMany: typeof loadSucursalesMany
}

interface IResultAuthApi extends IResultApi {
    response: { token: string, refreshToken: string }
}

interface IDatosLogin {
    resultAuthApi: IResultAuthApi
    cliente: ICliente
    usuario: IUsuario
    tipoUsuario: string
    cotizacion: CotizacionHistorialDto
    cotizacionId: number,
    etiquetas: any,
    idioma: string,
    diasRAD: string,
    tieneConveniosHD: boolean, 
    logoutTime : number,
    zonaHorariaServidor: string,
    esCargaMasivaPortalExterno:boolean, 
    ocultarPortal:boolean,
    esPortalExternoGuias: boolean,
    unidades: IUnidad[]
}

interface IUnidad{
    unidad_id:number,
    unidad_nombre:string,
    tipo_unidad_nombre:string
}

type Props = IDatosLogin & DispatchProps

const App = ({ saveCliente, setUsuario, setAyuda, loadPaises, loadDiasFestivos, loadSucursalesMany }: Props) => {


    const apiSource = useCommonApi();
    const [showLoading, setLoading] = useState(true);
    const [usuarioIdLogin, setLoginUsuarioId] = useState(0);
    const [clienteIdLogin, setClienteUsuarioId] = useState(0);
    const [usuarioLogeado, setUsuarioLogeado] = useState(false);
    const [usuarioInvitado, setUsuarioInvitado] = useState(false);
    const [logoutTimer, setLogoutTimer] = useState(60); //Valor default por si consulta de API falla
    const [timeZoneServer, setTimeZoneServer] = useState("");
    const history = useHistory();
    const isDuplicateTab = ControlBroadcastChannel();
    const [debeRedireccionar, setDebeRedireccionar] = useState(false);

    const LoginByToken = async (token) => {
        const result = await apiSource.postAsync<IDatosLogin>("login/login-by-token", { token });
        return result;
    };

    const abrirSesionSiHaceFalta = (tokenNuevo: boolean): Promise<void> => {
        if (!tokenNuevo && obtenerSesion()) {
            return Promise.resolve();
        }

        retirarSesion();

        return registrarApertura((async () => {
            try {
                const resultado = await apiSource.postAsync<{ identificador: string }>(RUTA_DE_APERTURA);

                if (resultado && resultado.identificador) {
                    guardarSesion(resultado.identificador);
                } else {
                    retirarSesion();
                }
            } catch (e) {
                retirarSesion();
            }
        })());
    };

    const loginData = async (clienteId, usuarioId, userName) => {
        const result = await apiSource.obtenerAsync<IDatosLogin>("login/login-data", { clienteId: clienteId, usuarioId: usuarioId });
        return result;
    };

    const setUnidades = (result) =>{
        var unidades =  JSON.stringify(result.unidades);
        localStorage.setItem("unidades",unidades);
    }

    setAyuda(ayudasVisuales);

    React.useEffect(() => escucharRenovaciones(), []);

    React.useEffect(() => {

        const dominio = document.referrer;
        
        const token = sessionStorage.getItem("tokenEntrada") !== null ? sessionStorage.getItem("token") : null;
        sessionStorage.removeItem("tokenEntrada");
        const tokenStorage = sessionStorage.getItem("token");
        const usuarioStorage = localStorage.getItem("usuarioId");
        const usuarioNombreStorage = localStorage.getItem("usuario_nombre");
        const clienteStorage = localStorage.getItem("clienteId");

        const tokenFromUrl = token;
        const sessionToken = token !== null ? token : sessionStorage.getItem("token");

        if(sessionToken !== null && sessionToken){
            sessionStorage.setItem("token", sessionToken);
        }

        retirarTokenDeLaDireccion();
        localStorage.removeItem("token");

        // Validar si hay un token válido
        const activeToken = sessionStorage.getItem("token");
       
        if(process.env.REACT_APP_VALID_DOMAIN != dominio && token != null 
            || activeToken == null || localStorage.getItem("SesionCerrada") === "true"){
            setDebeRedireccionar(true);
        }

        if (activeToken === null) {
            swal.fire({
                titleText: '¡Error!',
                text: traducirLabel(311), // "Usuario no encontrado",
                type: 'error',
            });
            sessionStorage.removeItem("token");
            retirarSesion();
        }
        if (activeToken !== null) {
            localStorage.removeItem("usuarioId");
            localStorage.removeItem("clientId");
            localStorage.removeItem("tipo_usuario");
            localStorage.removeItem("etiquetas");
            localStorage.removeItem("idioma");
            localStorage.removeItem("diasRad");
            localStorage.removeItem("unidades");
            localStorage.removeItem("ocultarPortal");

            abrirSesionSiHaceFalta(tokenFromUrl !== null).then(() => LoginByToken(activeToken)).then(result => {
                if (result !== null && result?.idioma !== null) {
                    localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                    localStorage.setItem("idioma", result.idioma);
                    setLogoutTimer(result.logoutTime);
                    setTimeZoneServer(result.zonaHorariaServidor);
                    if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                        localStorage.setItem("diasRad", result.diasRAD);
                    }
                    else{
                        localStorage.setItem("diasRad", "0");
                    }
                }
                const esCargaMasiva = String(result.esCargaMasivaPortalExterno ? 'true' : 'false');
                localStorage.setItem("verCargaMasiva", esCargaMasiva);

                const ocultarPortal = String(result.ocultarPortal ? 'true' : 'false');
                localStorage.setItem("ocultarPortal", ocultarPortal);
                localStorage.setItem(
                    "verGuiasPortalExterno",
                    result.esPortalExternoGuias ? "true" : "false"
                );
                //Le asigna un id consecutio a los documentos del cliente
                let documentoId = 0;
                if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                    localStorage.setItem("clienteId", result.cliente.id.toString());
                    setClienteUsuarioId(result.cliente.id);
                    if (result.cliente?.documentos !== null) {
                        result.cliente.documentos?.forEach(d => {
                            documentoId++;
                            d.id = documentoId;
                        });
                    }
                    
                    result.cliente.esCargaMasivaPortalExterno = result.esCargaMasivaPortalExterno;
                    result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                    result.cliente.habilitarDatosComplementarios = false;
                    if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                        result.cliente.habilitarDatosComplementarios = true;
                    }
                    if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                        result.cliente.habilitarDatosComplementariosCartaPorte = true;
                    }
                    if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                        localStorage.setItem('CartaPorte', result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo);
                        result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                    } else {
                        localStorage.setItem('CartaPorte', "false");
                    }
                    if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                        result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                    }
                    if (result.cliente.clienteConfiguracionRadEadCedis) {
                        result.cliente.clienteConfiguracionRadEadCedis = result.cliente.clienteConfiguracionRadEadCedis;
                    }
                    if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                        result.cliente.habilitarValidacionCoberturaEAD = true;
                    }
                    if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                        result.cliente.habilitarValidacionCoberturaRAD = true;
                    }
                    result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                    //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                    result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                    //result.cliente.clienteConfiguracionMarkupDetalle = 0;
                    saveCliente(result.cliente);
                    setLoading(false);
                    setUnidades(result);

                }
                else {
                    setLoading(false);
                    swal.fire({
                        titleText: '¡Error!',
                        text: traducirLabel(311), // "Usuario no encontrado",
                        type: 'error',
                    });
                }
                if (result.usuario && result.usuario.id !== null) {
                    result.usuario.esInvitado = false;
                    //result.usuario.nombre = result.usuario.nombre;
                    if (result.tipoUsuario === 'Invitado') {
                        setUsuarioInvitado(true);
                        result.usuario.esInvitado = true;
                    }
                    else {
                        setUsuarioInvitado(false);
                    }
                    localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                    setLoginUsuarioId(result.usuario.id);
                    setUsuarioLogeado(true);
                    setUsuario(result.usuario);
                    localStorage.setItem("usuarioId", result.usuario.id.toString());
                    localStorage.setItem("usuario_nombre", result.usuario.nombre);
                    localStorage.setItem("tipo_usuario", result.tipoUsuario);
                }
            });
        }
        else if (tokenStorage !== null && usuarioStorage !== null) {
            loginData(Number(clienteStorage), Number(usuarioStorage), usuarioNombreStorage).then(result => {
                setLogoutTimer(result.logoutTime);
                setTimeZoneServer(result.zonaHorariaServidor);
                let documentoId = 0;
                if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                    setClienteUsuarioId(result.cliente.id);

                    result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                    result.cliente.habilitarDatosComplementarios = false;
                    if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                        result.cliente.habilitarDatosComplementarios = true;
                    }
                    if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                        result.cliente.habilitarDatosComplementariosCartaPorte = true;
                    }
                    if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                        localStorage.setItem('CartaPorte', result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo);
                        result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                    } else {
                        localStorage.setItem('CartaPorte', "false");
                    }
                    if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                        result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                    }
                    if (result.cliente.clienteConfiguracionRadEadCedis) {
                        result.cliente.clienteConfiguracionRadEadCedis = result.cliente.clienteConfiguracionRadEadCedis;
                    }

                    if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                        result.cliente.habilitarValidacionCoberturaEAD = true;
                    }
                    if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                        result.cliente.habilitarValidacionCoberturaRAD = true;
                    }
                    //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                    result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                    //result.cliente.clienteConfiguracionMarkupDetalle = 0;

                    if (result.cliente?.documentos !== null) {
                        result.cliente.documentos?.forEach(d => {
                            documentoId++;
                            d.id = documentoId;
                        });
                    }

                    result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                    localStorage.setItem(
                        "verCargaMasiva",
                        result.esCargaMasivaPortalExterno ? "true" : "false"
                    );
                    localStorage.setItem(
                        "verGuiasPortalExterno",
                        result.esPortalExternoGuias ? "true" : "false"
                    );
                    localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                    saveCliente(result.cliente);
                    setLoading(false);
                    localStorage.setItem("idioma", result.idioma);
                    if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                        localStorage.setItem("diasRad", result.diasRAD);
                    }
                    else{
                        localStorage.setItem("diasRad", "0");
                    }
                    
                }
                else {
                    setLoading(false);
                    swal.fire({
                        titleText: '¡Error!',
                        text: traducirLabel(311), // "Usuario no encontrado",
                        type: 'error',
                    });
                }

                if (result.usuario && result.usuario.id !== null) {
                    result.usuario.esInvitado = false;
                    if (result.tipoUsuario === 'Invitado') {
                        setUsuarioInvitado(true);
                        result.usuario.esInvitado = true;
                    }
                    else {
                        setUsuarioInvitado(false);
                    }
                    setLoginUsuarioId(result.usuario.id);
                    setUsuarioLogeado(true);
                    setUsuario(result.usuario);
                    setUnidades(result);
                }
            });
            setUsuarioLogeado(true);
            setLoading(false);
        }
        else {
            setUsuarioLogeado(false);
            setLoading(false);
        }

        if (usuarioLogeado && usuarioInvitado) {
            history.push("/nueva-cotizacion");
        }
        loadPaises();
        loadDiasFestivos();
        loadSucursalesMany();
    }, []);


    if (isDuplicateTab) {
        return (
            <div style={{ textAlign: "center", marginTop: "2rem" }}>
                <img src='https://almex.com.mx/wp-content/themes/almex-theme/dist/images/logo_9421de73.svg' width={500}></img>
                <h2 style={{color: '#00653B'}}>No es posible tener más de una pestaña o ventana abierta para esta sesión de usuario.</h2>
            </div>
          );
    }

    return (

        <main>
            {debeRedireccionar && 
            <Router>
                <Route path="/sesion-cerrada" component={SesionCerrada} />
                <Redirect to="/sesion-cerrada" />
            </Router>
            }
            {!debeRedireccionar && !usuarioInvitado && timeZoneServer!==undefined && timeZoneServer!=="" &&
                <Router>
                    <AutoLogout inactivityLimitInMinutes={logoutTimer}></AutoLogout>
                    <Switch>
                        <Route exact path="/" component={() => (<Body usuario={usuarioIdLogin} cliente={clienteIdLogin} />)} />
                        <Route exact path="/nueva-cotizacion" component={() => (<BodyCotizacion cotizacionId={0} />)} />
                        <Route exact path="/nueva-solicitud" component={() => (<BodySolicitud cotizacionId={0} />)} />
                        <Route exact path="/nueva-guia" component={() => (<BodyGuia />)} />
                        <Route exact path="/guia" component={() => (<BodyGuiaConsulta />)} />
                        <Route exact path="/carga-masiva" component={() => (<BodyCargaMasiva />)} />
                    </Switch>
                </Router>
            }
            {usuarioInvitado && timeZoneServer!==undefined &&timeZoneServer!=="" &&
                <Router>
                    <AutoLogout inactivityLimitInMinutes={logoutTimer}></AutoLogout>
                    <Switch>
                        <Route exact path="/" component={() => (<Body usuario={usuarioIdLogin} cliente={clienteIdLogin} />)} />
                        <Route exact path="/nueva-cotizacion" component={() => (<Body usuario={usuarioIdLogin} cliente={clienteIdLogin} />)} />
                        <Route exact path="/nueva-solicitud" component={() => (<BodySolicitud cotizacionId={0} />)} />
                        <Route exact path="/carga-masiva" component={() => (<BodyCargaMasiva />)} />
                    </Switch>
                </Router>
            }

            {
                showLoading &&
                //Procesando
                <> <LoadingDialog titulo={'Procesando'} abierto={true} /></>
            }
        </main>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario,
    ayuda: state.ayuda,
    idiomaId: state.idioma
});

const mapDispatchToProps = {
    saveCliente: saveCliente,
    setUsuario: setUsuario,
    setSolicitud: setSolicitud,
    setAyuda: setAyuda,
    loadPaises: loadPaises,
    loadDiasFestivos: loadDiasFestivos,
    loadSucursalesMany: loadSucursalesMany
};

export default connect(mapStateToProps, mapDispatchToProps)(App);